import {NgModule} from "@angular/core";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateStore} from "@ngx-translate/core/src/translate.store";
import {MultiTranslateHttpLoader} from '@digicerba/common';
import {environment} from "@environments/environment";

export function HttpMultiLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    {prefix: environment.i18nHFBaseUrl, suffix: '.json'},
    {prefix: environment.i18nBaseUrl, suffix: '.json'},
  ]);
}

@NgModule({
  imports: [
    HttpClientModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpMultiLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [
    TranslateModule
  ],
  providers: [TranslateStore]
})
export class i18nModule {

  constructor(translate: TranslateService) {
    translate.setDefaultLang('fr');
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/common/config/i18n.module.ts